import { message } from 'antd';
import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import deleteVacancyAPI from '../../api/delete-vacancy';
import deleteVacancyGroupAPI from '../../api/delete-vacancy-group';
import {
  receiveVacancyDelete,
  receiveVacancyGroupDelete,
  rejectVacancyGroupDelete,
  requestVacancies,
  requestVacancyDelete,
  requestVacancyGroup,
  requestVacancyGroupDelete,
} from '../actions/admin-page';

interface IDeleteVacancyGroupAction {
  type: string;
  payload: {
    id: string;
    divisionName: string;
    searchValue: string;
  }
}

interface IDeleteVacancyAction {
  type: string;
  payload: {
    id: string;
    division?: string;
    search?: string;
    group?: string;
    grade?: string;
    status?: string;
    responsible?: string;
    showOnlyMyVacancies?: boolean;
    showPrivateVacancies?: boolean;
  }
}

const deleteVacancy = function* deleteVacancy(action: IDeleteVacancyAction) {
  try {
    yield call(deleteVacancyAPI, action.payload.id);
    yield put(requestVacancies({
      division: action.payload.division,
      search: action.payload.search,
      group: action.payload.group,
      grade: action.payload.grade,
      status: action.payload.status,
      responsible: action.payload.responsible,
      showOnlyMyVacancies: action.payload.showOnlyMyVacancies,
      showPrivateVacancies: action.payload.showPrivateVacancies,
    }));
    yield put(receiveVacancyDelete());
    message.success({
      content: 'Вакансия успешно удалена',
      style: { textAlign: 'right' },
    });
  } catch (error) {
    yield put(rejectVacancyGroupDelete({ error }));
  }
};

const deleteVacancyGroup = function* deleteVacancyGroup(action: IDeleteVacancyGroupAction) {
  try {
    yield call(deleteVacancyGroupAPI, action.payload.id);
    yield put(requestVacancyGroup({ division: action.payload.divisionName, searchValue: action.payload.searchValue }));
    yield put(receiveVacancyGroupDelete());
    message.success({
      content: 'Группа успешно удалена',
      style: { textAlign: 'right' },
    });
  } catch (error) {
    yield put(rejectVacancyGroupDelete({ error }));
  }
};

export default function* deleteVacancyGroupWatcher() {
  yield takeLatest(requestVacancyDelete, deleteVacancy);
  yield takeLatest(requestVacancyGroupDelete, deleteVacancyGroup);
}
